import React from 'react'

// Percentages are stored as fractions (0.15) and shown as percents (15)
export const thresholdToDisplay = (unit, value) => (unit === '%' ? +(Number(value) * 100).toFixed(4) : value)

const formatThresholdValue = (unit, value) => {
    if (value === '' || value === undefined || value === null || Number.isNaN(Number(value))) return '…'
    if (unit === '%') return `${value}%`
    if (unit === '$') return `$${value}`
    return String(value)
}

/**
 * A rule's one-sentence summary with its {threshold} placeholders filled in and bolded.
 * ``displayValues`` maps threshold key -> value as displayed (percent, not fraction), so the
 * settings page can pass the values being edited and the guide the values in force.
 */
export const AmazonAnomalyRuleSummary = ({ rule, displayValues, className = 'small mb-2' }) => {
    if (!rule.summary) return null
    const units = Object.fromEntries(rule.thresholds.map(t => [t.key, t.unit]))
    const parts = rule.summary.split(/(\{\w+\})/g).map((part, i) => {
        const match = part.match(/^\{(\w+)\}$/)
        if (!match) return part
        const key = match[1]
        return <strong key={i}>{formatThresholdValue(units[key], displayValues[key])}</strong>
    })
    return <div className={className}>{parts}</div>
}

/** Threshold values in force for a rule from the settings payload, as displayed. */
export const ruleDisplayValues = (rule) => Object.fromEntries(
    rule.thresholds.map(t => [t.key, thresholdToDisplay(t.unit, t.value)]),
)

export default AmazonAnomalyRuleSummary
